import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setSerial
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onCloseModal
 * @method onSerialExpire
 * @method onSlideToUsed
 * event
 * @event sendCloseModal
 * @event sendSerialExpire
 * @event sendSlideToUsed
 */
export function SerialModalController() {
    this.serialModel = null;
    this.historyBtn = true;
    this.busModal = mitt();

    this.callbackClose = null;
    this.callbackSerialExpire = null;
    this.callbackSlideToUsed = null;

    //#region setter
    this.setSerial = function (serialModel) {
        this.serialModel = serialModel;
        return this;
    };
    this.setHistoryBtn = function (isShow) {
        this.historyBtn = isShow;
        return this;
    }
    this.clearModal = function () {
        this.serialModel = null;
        this.historyBtn = true;
        this.callbackClose = null;
        this.callbackSerialExpire = null;
        this.callbackSlideToUsed = null;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            serialModel: this.serialModel,
            historyBtn: this.historyBtn
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onCloseModal = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackClose = callback;
        }
    };
    this.sendCloseModal = function(data) {
        if (Util.isFunction(this.callbackClose)) {
            this.callbackClose(data);
        }
    };

    this.onSerialExpire = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackSerialExpire = callback;
        }
    };
    this.sendSerialExpire = function(data) {
        if (Util.isFunction(this.callbackSerialExpire)) {
            this.callbackSerialExpire(data);
        }
    };

    this.onSlideToUsed = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackSlideToUsed = callback;
        }
    };
    this.sendSlideToUsed = function(data) {
        if (Util.isFunction(this.callbackSlideToUsed)) {
            this.callbackSlideToUsed(data);
        }
    };
    //#endregion event
}
